import React from "react"

import { useActiveOrganization } from "@/contexts"
import { BillPdfPreviewAnalysisDetailDialog } from "@/modules/data/components/bill-pdf-preview-analysis-detail-dialog"
import { BillPdfPreviewAnalysisStrip } from "@/modules/data/components/bill-pdf-preview-analysis-strip"
import {
  type BillPdfAnalysisDetailVariant,
  type BillPdfAnalysisRecord,
  type BillPdfUploadSessionAnalysis,
  useBillPdfUploadSessionAnalysis,
} from "@/modules/data/services/use-bill-pdf-upload-session-analysis"

interface BillPdfPreviewAnalysisPanelProps {
  sessionId: string
}

const getRecordsForVariant = (
  analysis: BillPdfUploadSessionAnalysis | undefined,
  variant: BillPdfAnalysisDetailVariant | null
): BillPdfAnalysisRecord[] => {
  if (variant === "gaps") {
    return analysis?.gaps ?? []
  }

  return []
}

export const BillPdfPreviewAnalysisPanel: React.FC<
  BillPdfPreviewAnalysisPanelProps
> = ({ sessionId }) => {
  const { activeOrganization } = useActiveOrganization()
  const [detailVariant, setDetailVariant] =
    React.useState<BillPdfAnalysisDetailVariant | null>(null)
  const {
    billPdfUploadSessionAnalysisData,
    billPdfUploadSessionAnalysisIsError,
    billPdfUploadSessionAnalysisIsLoading,
  } = useBillPdfUploadSessionAnalysis({
    organizationId: activeOrganization?.id,
    sessionId,
  })

  return (
    <>
      <BillPdfPreviewAnalysisStrip
        analysis={billPdfUploadSessionAnalysisData ?? null}
        isError={billPdfUploadSessionAnalysisIsError}
        isLoading={billPdfUploadSessionAnalysisIsLoading}
        onOpenGaps={() => {
          setDetailVariant("gaps")
        }}
      />
      <BillPdfPreviewAnalysisDetailDialog
        open={detailVariant != null}
        records={getRecordsForVariant(
          billPdfUploadSessionAnalysisData,
          detailVariant
        )}
        variant={detailVariant}
        onClose={() => {
          setDetailVariant(null)
        }}
      />
    </>
  )
}
